import React from 'react';

const Header = ({ emailValue, handleGoToCalcSubmit }) => {
  return (
    <div className="header-wrapper">
      <h2>Fee Calculator</h2>
      <p>
        At Presidential Title we're focused on making your Title and Closing experience smarter,
        faster and easier for less
      </p>
      <div className="email-wrapper">
        <span className="email-value">{emailValue}</span>
        {emailValue && (
          <button className="btn btn-link" onClick={() => handleGoToCalcSubmit('')}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_192_437)">
                <path
                  d="M7.3335 2.66667H2.66683C2.31321 2.66667 1.97407 2.80715 1.72402 3.05719C1.47397 3.30724 1.3335 3.64638 1.3335 4V13.3333C1.3335 13.687 1.47397 14.0261 1.72402 14.2761C1.97407 14.5262 2.31321 14.6667 2.66683 14.6667H12.0002C12.3538 14.6667 12.6929 14.5262 12.943 14.2761C13.193 14.0261 13.3335 13.687 13.3335 13.3333V8.66667M12.3335 1.66667C12.5987 1.40145 12.9584 1.25246 13.3335 1.25246C13.7086 1.25246 14.0683 1.40145 14.3335 1.66667C14.5987 1.93189 14.7477 2.2916 14.7477 2.66667C14.7477 3.04174 14.5987 3.40145 14.3335 3.66667L8.00016 10L5.3335 10.6667L6.00016 8L12.3335 1.66667Z"
                  stroke="#09090B"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_192_437">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default Header;
